import Icons from './Icons';

const CompletedMessage: React.FC = () => {
  return (
    <div className='flex items-center gap-1'>
      <Icons.Check />
      <p className='text-lg font-medium text-green-100 leading-none'>Completed</p>
    </div>
  );
};

export default CompletedMessage;
